import React from "react";
import { useTable } from "../../Components/useTable";

const SendersLevel = () => {
  const type = "Sending Level";
  const limitPerpage = 100;
  const pageRowslinit = [100, 200, 500, 1000];
  const headCells = [
    { id: "pictureUrl", numeric: false, label: "Image" },
    { id: "diamond", numeric: false, label: "Diamonds" },
    { id: "level", numeric: false, label: "Level" },
    { id: "createdAt", numeric: false, label: "Created at" },
    { id: "action", numeric: false, label: "Action" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
    limitPerpage,
    pageRowslinit,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default SendersLevel;
